import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const Stn_Outward_Report = () => {
   useAuthRedirect();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);

  const branch = localStorage.getItem("branch");

  const canView  = hasPermission("STN Outward Report", "view");

  useEffect(() => {
    fetchData();
  }, [branch]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/stnOutward_report`, {
        params: { branch },
      });
      setData(response.data.stnOutwardReport || []);
      setFilteredData(response.data.stnOutwardReport || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setFilteredData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = async () => {
    if (!fromDate || !toDate) {
      Swal.fire("Please select both From and To dates");
      return;
    }

    if (fromDate > toDate) {
      Swal.fire("From Date should not be greater than To Date");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/stnOutward_report`, {
        params: { branch, fromDate, toDate },
      });
      setData(response.data.stnOutwardReport || []);
      setFilteredData(response.data.stnOutwardReport || []);
      setCurrentPage(1);
    } catch (error) {
      console.error("Error filtering data:", error);
      setData([]);
      setFilteredData([]);
    } finally {
      setLoading(false);
    }
  };

  const clearDates = () => {
    setFromDate("");
    setToDate("");
    fetchData();
  };

  const handleSearch = (e) => {
    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === "") {
      setFilteredData(data);
      return;
    }

    const filtered = data.filter((item) =>
      (String(item.sfIssuesHeader_number || "").toLowerCase().includes(term) ||
        String(item.branchCode || "").toLowerCase().includes(term))
    );

    setFilteredData(filtered);
  };

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData ? filteredData.slice(indexOfFirstItem, indexOfLastItem) : [];

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <h2 className="add-txt">STN Outward Report</h2>
          <Time />
        </section>

        {/* Date Filter */}
        <div className="month-year-container">
          <p className="title">Select your Date :</p>
          <div className="select-container">
            <input
              type="date"
              className="custom-select"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
            <input
              type="date"
              className="custom-select"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
          <button className="custom-button" onClick={handleFilter}>
            Submit
          </button>
          <button className="custom-button" onClick={clearDates}>
            View All
          </button>
        </div>

        {/* Print Button */}
        <div className="add-new-container">
          <Link to={`/inventory/stn_outwardreport_print`} target="_blank">
            <button className="add-new-btn">Print</button>
          </Link>
        </div>

        {/* Search Filter */}
        <div className="search-filter">
          <p>Search: </p>
          <input
            type="text"
            placeholder="Search by STN No"
            value={searchTerm}
            onChange={handleSearch}
            className="search-input"
          />
        </div>

        {/* Table */}
        <div className="content-table">
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Date</th>
                <th>STN No</th>
                <th>To Branch</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="4" className="loading-text">
                    Loading data, please wait...
                  </td>
                </tr>
              ) : currentData.length > 0 ? (
                currentData.map((item, index) => (
                  <tr key={index}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{new Date(item.sfIssuesHeader_date).toLocaleDateString()}</td>
                    <td>
                      <Link to={`/inventory/stnViewOutwardSingle_report/${item.sfIssuesHeader_number}/${item.branchCode}`}>
                        {item.sfIssuesHeader_number}
                      </Link>
                    </td>
                    <td>{item.sfIssuesHeader_branchcode}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4">No Data Available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="pagination">
          <button onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}>
            Previous
          </button>
          <button onClick={() => paginate(1)} className={currentPage === 1 ? "active" : ""}>
            1
          </button>
          {filteredData.length > 0 &&
            [...Array(Math.min(3, Math.ceil(filteredData.length / itemsPerPage) - 1))].map((_, index) => {
              const pageNumber = currentPage + index;
              if (pageNumber > 1 && pageNumber <= Math.ceil(filteredData.length / itemsPerPage)) {
                return (
                  <button
                    key={pageNumber}
                    onClick={() => paginate(pageNumber)}
                    className={currentPage === pageNumber ? "active" : ""}
                  >
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })}
          <button
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Stn_Outward_Report;
